import React from "react";
import { Outlet } from "react-router-dom";
import { DashboardSidebar } from "@/components/dashboard/sidebar";
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import { useAuth as UseAuth } from "@/components/dashboard/contexts/auth-context";
const index = () => {
	const { user, loading } = UseAuth();

	// useEffect(() => {
	//   if (!loading && !user) {
	//     router.push("/auth/login?redirect=/dashboard")
	//   }
	// }, [user, loading, router])

	if (loading) {
		return (
			<div className="flex h-screen items-center justify-center">
				<div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
			</div>
		);
	}

	// if (!user) {
	//   return null
	// }

	return (
		<SidebarProvider className={"max-h-screen h-full overflow-hidden"}>
			<DashboardSidebar />
			<SidebarInset className={"overflow-scroll"}>
				<div className="container py-6 mx-auto">
					<Outlet />
				</div>
			</SidebarInset>
		</SidebarProvider>
	);
};

export default index;
